<script setup>
import PdfViewer from '@templates/pdfViewer/PdfViewer.vue';
import { url } from '@/config/urls';
</script>

<template>
    <PdfViewer title="利用規約" :api-url=url.api.terms.pdf />
</template>